import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取账户信息
export const getAccountData = async (params: object) => {
  return await POST({
    url: Api.getAccountData,
    params: {
      ...params
    },
    showError: false
  })
}
// 获取收入信息
export const getIncomeData = async (params: object) => {
  return await GET({
    url: Api.getIncomeData,
    params: {
      ...params
    },
    showError: false
  })
}
